import React, { useState, useEffect } from 'react'

import HoverTooltip from '../../../../../../components/HoverTooltip'
import MoneyInput from '../../../../../../components/form/MoneyInput'
import CurrencySelector from '../../../../../../components/currency/CurrencySelector'

import PerformanceTable from './PerformanceInfoTable/PerformanceTable'

import PerformanceDocTable from './PerformanceInfoTable/PerformanceDocTable'
import PerformancePaymentTable from './PerformanceInfoTable/PerformancePaymentTable'

import Section from '../../../../../../components/Section'
import { Contract, ContractPerformance } from '../../../types'

import { CurrencyList } from '../../types'

import { PerformanceDocsError } from '../types'

interface PerformanceCurrency {
    currencyCharCode: string | null
    currencyName: string | null
    currencyDigitalCode: number | null
}

type Props = {
    theme: string
    perfAction: boolean
    contractGuid: string | undefined
    contractRegNumber: string | undefined
    performance: ContractPerformance
    performanceGuid: string | undefined
    currencyList: CurrencyList[]
    performanceCurrency: PerformanceCurrency
    onPerformanceDocs: (have_perf_docs: boolean) => void
    errors?: PerformanceDocsError
    onAnyEdit: () => void
}

const formatNumber = (num: number | string | null | undefined): string => {
    if (num === null || num === undefined) return '-' // Обрабатываем пустые значения

    const parsedNum = typeof num === 'number' ? num : parseFloat(num)

    if (isNaN(parsedNum)) {
        return '-' // Обрабатываем некорректные значения
    }

    return parsedNum
        .toFixed(2) // Два знака после запятой
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ') // Разделяем тысячные пробелами
        .replace('.', ',') // Заменяем точку на запятую
}

const PerformanceDocs: React.FC<Props> = (props) => {
    return (
        <Section title="Информация о документах приемки">
            <div className="flex flex-col w-full gap-x-5 space-y-3">
                <div className="flex flex-col w-full gap-x-5 ">
                    <div className="flex flex-col min-w-[200px] gap-3">
                        <PerformanceDocTable
                            theme={props.theme}
                            perfAction={props.perfAction}
                            performanceGuid={props.performanceGuid}
                            contractGuid={props.contractGuid}
                            contractRegNumber={props.contractRegNumber}
                            currencyList={props.currencyList}
                            performanceCurrency={props.performanceCurrency}
                            onPerformanceDocs={props.onPerformanceDocs}
                            errors={props.errors}
                            onAnyEdit={props.onAnyEdit}
                        />
                    </div>
                </div>
            </div>
        </Section>
    )
}

export default PerformanceDocs
